import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL + "/OfficeBank";

export const getOfficeBank = async () => {
  return axios.get(`${api_base_url}`).then((res) => {
    return res?.data;
  });
};

export const addOfficeBank = async (bank) => {
  return axios.post(`${api_base_url}`, {
    ...bank,
  });
};

export const updateOfficeBank = async (bank) => {
  const formData = new FormData();

  bank.bankId && formData.append("bankId", bank.bankId);
  bank.bankName && formData.append("bankName", bank.bankName);
  bank.createdBy && formData.append("createdBy", bank.createdBy);
  bank.createdDate && formData.append("createdDate", bank.createdDate);
  bank.isActive !== undefined && formData.append("isActive", bank.isActive);

  return axios.put(`${api_base_url}/${bank.bankId}`, formData);
};

export const deactivateOfficeBank = async (bankIds) => {
  return await axios.delete(`${api_base_url}/DeactivateOfficeBank`, {
    data: bankIds,
  });
};
